import React from 'react';

const AnimeTrailer = ({ trailer }) => {
  if (!trailer) {
    return <div className="no-trailer">No trailer available</div>;
  }

  return (
    <div className="tab-content trailer-content">
      <div className="trailer-player">
        {trailer.embed_url ? (
          <iframe
            src={trailer.embed_url}
            title="Official Trailer"
            allowFullScreen
          />
        ) : (
          <div className="no-trailer">No trailer available</div>
        )}
      </div>
      {trailer.images && (
        <div className="trailer-thumbnails">
          {Object.entries(trailer.images).map(([size, url]) => (
            <a key={size} href={trailer.url} target="_blank" rel="noopener noreferrer">
              <img src={url} alt={`Trailer ${size} thumbnail`} />
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnimeTrailer;